//import { baseURL } from '@/config'
const baseURL = window.baseURL
const UIMSUrl = baseURL.Gateway + 'uims/api/'
const SalesUrl = baseURL.Gateway + 'sales/api/'
const FileServer = baseURL.Gateway + 'fileserver/api/'
const PortalUrl = baseURL.Gateway + 'portal/api/'
const FileHost = baseURL.FileHost
const MarketinglUrl = baseURL.Gateway + 'marketing/api/'
const LogUrl = baseURL.Gateway + 'log/api/'
const ServiceUrl = baseURL.Gateway + 'service/api/'
const FinanceUrl = baseURL.Gateway + 'finance/api/'
const ManagerUrl = baseURL.Gateway + 'manager/api/'

const api = {}

api.defaultTenant = 'zeyu'
api.H5Host = baseURL.H5Host
api.UploadImage = FileServer + 'File/UploadImage'
api.UploadVideo = FileServer + 'File/UploadVideo'
api.UploadAudio = FileServer + 'File/UploadAudio'
api.UploadAttachment = FileServer + 'File/UploadAttachment'
api.FileHost = FileHost

api.LogAppend = LogUrl + 'Log/Append'
// namespaced: user
api.GetTenantByCode = UIMSUrl + 'Tenant/GetTenantByCode'
api.TenantAvailable = UIMSUrl + 'Tenant/Available'
api.TenantRegister = UIMSUrl + 'Tenant/Register'
api.TenantGetListByOwner = UIMSUrl + 'Tenant/GetListByOwner'
api.StaffRegister = UIMSUrl + 'Staff/Register' //注册为当前租户职员
api.StaffGetStaffsByStaffIds = UIMSUrl + 'Staff/GetStaffsByStaffIds' //判断是不是职员

api.login = UIMSUrl + 'User/Login'
api.GetUserInfo = UIMSUrl + 'User/GetUserInfo'
api.GetCurrentUserInfo = UIMSUrl + 'User/GetCurrentUserInfo'
api.GetUserInfoByAccount = UIMSUrl + 'User/GetUserInfoByAccount' //根据account 查找用户
api.GetUserList = UIMSUrl + 'User/GetUserList'

// namespaced: user
api.WechatGetOpenAppID = UIMSUrl + 'Wechat/GetOpenAppID'
api.WechatLogin = UIMSUrl + 'Wechat/Login'

api.UserAddByWX = UIMSUrl + 'User/AddByWX' //添加一个微信 unionId 用户
api.UserWxLogin = UIMSUrl + 'User/WxLogin' //用微信ID登录
api.WechatGetJSSdkInfo = UIMSUrl + 'Wechat/GetJSSdkInfo'
// api.StaffRegister = UIMSUrl + 'Staff/Register' // 注册用户绑定租户
// api.StaffDeregister = UIMSUrl + 'Staff/Deregister' // 注册用户解绑租户
// api.QueryStaffList = UIMSUrl + 'Staff/QueryStaffList' // 租户下用户列表
// api.StaffRoleGetRightList = SalesUrl + 'StaffRole/GetRightList' // 查找租户下用户列表对应的role
api.UserRegister = UIMSUrl + 'User/Register' // 注册用户
api.UserUpdateAvatar = UIMSUrl + 'User/UpdateAvatar' // 更新用户头像
api.UserUpdateUserInfo = UIMSUrl + 'User/UpdateUserInfo'
api.VerfiyAccount4SendVerificationCode =
  UIMSUrl + 'User/VerfiyAccount4SendVerificationCode'
api.ResetPassword = UIMSUrl + 'User/ResetPassword'
api.SendVerificationCode = UIMSUrl + 'Verification/SendVerificationCode'
api.VerificateCode = UIMSUrl + 'Verification/VerificateCode'

api.WechatGetAppID = UIMSUrl + 'Wechat/GetAppID'
api.WechatAuthor = UIMSUrl + 'Wechat/Author'

api.PostPublish = PortalUrl + 'Post/Publish'
api.PostDelete = PortalUrl + 'Post/Delete'
api.PostUpdate = PortalUrl + 'Post/Update'
api.PostGet = PortalUrl + 'Post/Get'
api.PostSelectByIdList = PortalUrl + 'Post/SelectByIdList'
api.PostSelectMyPost = PortalUrl + 'Post/SelectMyPost'
api.PostSelectByTenant = PortalUrl + 'Post/SelectByTenant'
api.PostSelectByTopic = PortalUrl + 'Post/SelectByTopic'
api.PostSelectByAuthor = PortalUrl + 'Post/SelectByAuthor'
api.PostSearch = PortalUrl + 'Post/Search'
api.TopicTagGetList = PortalUrl + 'TopicTag/GetList'
api.TopicTagGetByIds = PortalUrl + 'TopicTag/GetByIds'
api.GetBatchArticleStatistics =
  PortalUrl + 'ArticleOperation/GetBatchArticleStatistics'
api.GetArticlesByAction = PortalUrl + 'ArticleOperation/GetArticlesByAction'
api.ArticleOperationCancel =
  PortalUrl + 'ArticleOperation/ArticleOperationCancel'
api.ArticleOperationIncrease =
  PortalUrl + 'ArticleOperation/ArticleOperationIncrease'

// api.SurveyGetDetails = SalesUrl + 'Survey/GetDetails' // 查询问卷下的所有题干
// api.SurveyResultStart = SalesUrl + 'SurveyResult/Start' //开始答题
// api.SurveyResultComplete = SalesUrl + 'SurveyResult/Complete' //结束答题
// api.SurveyAnswerAdd = SalesUrl + 'SurveyAnswer/Answer' //答题
// api.SurveyAnswerAnswerList = SalesUrl + 'SurveyAnswer/AnswerList' //答题
// api.SurveyAnswerModify = SalesUrl + 'SurveyAnswer/Modify' // 修改答案
// api.FormQueryFormSurvey = SalesUrl + 'Form/QueryFormSurvey' //查询工单对应的答卷详情

// // SalesUrl
// api.WorkflowStart = SalesUrl + 'Workflow/Start'
// api.WorkflowAdvancedApply = SalesUrl + 'Workflow/AdvancedApply' //二次咨询单
// api.WorkflowAgreement = SalesUrl + 'Workflow/Agreement' // 用户签署协议

api.IndustryGetAll = UIMSUrl + 'Industry/GetAll' //获取所有有效的行业定义
api.ChannelApply = MarketinglUrl + 'Channel/Apply' // 申请成为渠道
api.GetChannel = MarketinglUrl + 'Channel/GetChannel' // 获取渠道详情
api.OrderGetChannelOrder = SalesUrl + 'Order/GetChannelOrder' //
api.GetOrderStatistics = SalesUrl + 'Order/GetOrderStatistics' //
api.GetChannelOrderTotal = SalesUrl + 'Order/GetChannelOrderTotal' //
api.GetMarketingAll = SalesUrl + 'SurveyDispatch/GetMarketingAll' //
//学员端新增接口
api.GetSopNodeTree = ServiceUrl + 'SOPNode/GetSopNodeTree' // 服务下拉  20220617
api.GetNodeModulesInfo = ServiceUrl + 'SOPModule/GetNodeModulesInfo' // 服务模块
api.GetMyProductList = ServiceUrl + 'Form/GetMyProductList' // 学员端获取服务列表
api.MenteeSendMsg = ServiceUrl + 'Interaction/MenteeSendMsg' // 学员发送互动消息
api.GetList = ServiceUrl + 'CommentDimension/GetList' // 获取评价维度列表
api.Comment = ServiceUrl + 'ServiceComment/Comment' // 提交评价
api.SubmitHomework = ServiceUrl + 'MenteeDelivery/SubmitHomework' // 提交作業
api.ShowAssetDetail = ServiceUrl + 'Vod/ShowAssetDetail' // 查询媒体信息
api.GetDetail = SalesUrl + 'Product/Get' // 获取产品详情
api.GetCaseIds = SalesUrl + 'ProductCase/GetCaseIds' // 获取产品引用案例ID列表
api.SelectByIdList = PortalUrl + 'Post/SelectByIdList' // 按ID列表，查询帖子列表
api.RecordDeliveryPalyTime = ServiceUrl + 'Delivery/RecordDeliveryPalyTime' // 按ID列表，查询帖子列表
api.GetSopFormSimpleInfo = ServiceUrl + 'Form/GetSopFormSimpleInfo' // 按ID列表，查询帖子列表
api.SOPMenteeFinishNode = ServiceUrl + 'SOPNode/MenteeFinishNode' // 闯关模式学员点击完成
api.SOPMenteeRestartNode = ServiceUrl + 'SOPNode/MenteeRestartNode' // 重学本节课
api.AssetList = ServiceUrl + `Vod/ListAssetList`

api.FormBindFrom = ServiceUrl + 'Form/BindFrom' // 激活服务单
api.CheckAndFinishForm = ServiceUrl + 'SOP/CheckAndFinishForm'
api.PackageReceive = ServiceUrl + 'Package/Receive' // 学员领取服务包

api.GetAllSolutions = ServiceUrl + 'Form/GetAllSolutions'
api.GetMySolusions = ServiceUrl + 'Form/GetMySolusions'
api.CreateOpenClassForm = ServiceUrl + 'Form/CreateOpenClassForm'
api.CourseSharingCheck = ServiceUrl + 'Form/CourseSharingCheck'
api.CreateFormPurchaseOrder = ServiceUrl + 'Form/CreateFormPurchaseOrder' //创建服务计划购买订单
api.RecordNodeStayDuration = ServiceUrl + 'SOPNode/RecordNodeStayDuration' // 记录上报

api.FormGetAgreementWithSignatureInfo =
  ServiceUrl + 'Form/GetAgreementWithSignatureInfo' //获取产品协议和用户签署信息

api.ProductAgreementGetAgreement = SalesUrl + 'ProductAgreement/GetAgreement' //获取产品的协议内容
api.GetProductWorkflow = SalesUrl + 'WorkflowSetting/GetProductWorkflow' //获取产品的销售流程code列表

api.FormSignAgreement = ServiceUrl + 'Form/SignAgreement' //签署协议

api.WechatSubMerchantIsOpenWechatPayment =
  FinanceUrl + 'WechatSubMerchant/IsOpenWechatPayment'

//ManagerUrl
api.GetAgreementInfo = ManagerUrl + 'SettingCenter/GetAgreementInfo'

export default api
